import { View } from 'react-native'
import type { ContentBoxVariant } from '~/components/layout/ContentBox.tsx'
import { ActionButton, type Action } from '~/components/Actions.tsx'
import { cn } from '~/lib/utils.ts'

export default function AppActions({
  actions,
  className,
  actionClassName,
  toolbarActionClassName,
  toolbarClassName,
  variant = 'default',
}: {
  actions: Action[]
  className?: string
  actionClassName?: string
  toolbarActionClassName?: string
  toolbarClassName?: string
  variant?: ContentBoxVariant
}) {
  const columnActions = actions.filter((a) => !!a.description)
  const rowActions = actions.filter((a) => !a.description)

  const borderColorClass = cn(
    variant === 'transparent' && 'border-neutral-400/30',
    variant === 'default' && 'border-border',
    variant === 'muted' && 'border-[#D1D6F0]'
  )

  return (
    <View className={cn(className)}>
      {columnActions.map((action, index) => {
        const isLast = index === columnActions.length - 1
        const isLastElement = index === actions.length - 1

        return (
          <ActionButton
            key={action.key}
            action={action}
            className={cn(
              variant === 'transparent' && 'hover:bg-slate-100/40 active:bg-slate-100/60',
              variant === 'default' && 'hover:bg-slate-100 active:bg-slate-100',
              variant === 'muted' && 'hover:bg-slate-100 active:bg-slate-100',
              borderColorClass,
              isLastElement && 'rounded-b-content border-b-0',
              isLast && variant === 'muted' && 'border-b',
              actionClassName,
              action.className,
              isLast && rowActions.length > 0 && variant !== 'transparent' && 'rounded-b-none!'
            )}
          />
        )
      })}

      {rowActions.length > 0 && (
        <View
          className={cn(
            'flex-row items-center justify-evenly gap-2 rounded-full border px-4 py-4',
            borderColorClass,
            variant === 'transparent' && 'bg-neutral-400/30',
            variant === 'default' && '-mt-4 bg-border',
            variant === 'muted' && 'border-0',
            toolbarClassName
          )}>
          {rowActions.map((action) => (
            <ActionButton
              key={action.key}
              action={{
                ...action,
                buttonVariant: action.buttonVariant || 'ghost',
                buttonSize: action.buttonSize || 'sm',
                iconSize: action.iconSize || 16,
              }}
              className={cn(
                borderColorClass,
                variant === 'transparent' && 'hover:bg-muted',
                variant === 'default' && 'hover:bg-muted',
                variant === 'muted' && 'hover:bg-[#D1D6F0]',
                action.className,
                toolbarActionClassName
              )}
            />
          ))}
        </View>
      )}
    </View>
  )
}
